import { TransactionModule } from '@/modules/support/manage-user/transaction';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const transactionSearchSchema = z.object({
  userId: z.string().optional(),
  transactionId: z.string().optional(),
  page: z.number().optional(),
  perPage: z.number().optional(),
  createdAt: z.string().optional(),
  transactionType: z.string().optional(),
  transactionPurpose: z
    .enum([
      'aviator',
      'fantasy',
      'level_up',
      'referral',
      'withdrawal',
      'winnings_conversion',
      'balance_adjustment',
      'topup',
      'order',
      'influencer',
      'spin',
      'expiry',
      'unused_cash',
      'ludo',
    ])
    .optional(),
  currency: z.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/support/manage-user/transaction'
)({
  validateSearch: transactionSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <TransactionModule />;
}
